<template>
    <div>
        <el-table border :data="tableData">
            <el-table-column prop="sortNo" label="站点序号" width="80"></el-table-column>
            <el-table-column prop="siteName" label="平台名称">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <otpAdvance :params="siteParams" :disabled="scope.$index > 0 || ['YS'].includes(formData.orderType)"
                            :mValue="scope.row.siteName" :formData="scope.row"
                            @getAdvanceValue="getAdvanceValue($event, 'siteName', scope)"></otpAdvance>
                    </template>
                    <template v-else>{{scope.row.siteName}}</template>
                </template>
            </el-table-column>
            <el-table-column prop="whName" label="仓库名称">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <otpAdvance :params="(scope.$index === 0 && !['YS'].includes(formData.orderType)) ? whParams[0] : whParams[1]"
                            :mValue="scope.row.whName" :formData="scope.row"
                            @getAdvanceValue="getAdvanceValue($event, 'whName', scope)"></otpAdvance>
                    </template>
                    <template v-else>{{scope.row.whName}}</template>
                </template>
            </el-table-column>
            <el-table-column prop="stationType" label="站点属性">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <el-select
                            v-model="scope.row.stationType"
                            :clearable="true"
                            disabled
                        >
                            <el-option
                                v-for="(item,index) in stationTypeOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </template>
                    <template v-else>
                        {{scope.row.stationType | stationTypeFilter(stationTypeOptions)}}
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="transferFlag" label="是否快运">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <el-select
                            v-model="scope.row.transferFlag"
                            :clearable="true"
                            :disabled="scope.row.transferFlagDisabled"
                        >
                            <el-option
                                v-for="(item,index) in transferFlagOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                                :disabled="transferFlagOptionsDisabled(item, scope.$index)"
                            ></el-option>
                        </el-select>
                    </template>
                    <template v-else>
                        {{scope.row.transferFlag | transferFlagFilter}}
                    </template>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100" v-if="btnType !== 'check'">
                <template slot-scope="scope">
                    <el-button type="text" @click="deleteClick(scope.row, scope.$index)">删除</el-button>
                    <el-button type="text" @click="editClick(scope.row, scope.$index)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableFooter">
            <el-button type="text" @click="addDialogRow" :disabled="btnType === 'check'">+ 添加明细</el-button>
        </div>
    </div>
</template>
<script>
import otpAdvance from '@/components/lots/otpAdvance';
import { getTransferSite } from '../../../../api/timeManage';
export default {
    components: { otpAdvance },
    props: {
        tableData: {
            type: Array,
            default: () => {
                return [];
            }
        },
        formData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        btnType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            stationTypeOptions: [
                { 'value': 'PROPRIETARY', 'label': '自营' },
                { 'value': 'EXTERNAL', 'label': '外部' }
            ],
            transferFlagOptions: [
                { 'value': '1', 'label': '是' },
                { 'value': '0', 'label': '否' }
            ],
            siteParams: {
                'label': '平台名称',
                value: 'siteName',
                'mustFill': true,
                'prop': 'siteName',
                'advanceConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '平台名称' },
                    { 'prop': 'escoCompanyNo', 'value': '平台编码' }
                ],
                'tableConfig': [
                    { 'prop': 'escoCompanyNo', 'value': '平台编码' },
                    { 'prop': 'escoCompanyNameCn', 'value': '平台名称' },
                    { 'prop': 'branchCompanyNo', 'value': '分公司编码' },
                    { 'prop': 'branchCompanyName', 'value': '分公司名称' }
                ],
                'advanceUrl': '/searchPlatform',
                'type': 'advance',
                width: '120',
                noShowTooltip: true,
                'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
            },
            whParams: [
                {
                    'label': '仓库名称',
                    value: 'whName',
                    'prop': 'whName',
                    'mustFill': true,
                    'advanceConfig': [
                        { 'prop': 'cdwhName', 'value': '仓库名称' },
                        { 'prop': 'whCode', 'value': '仓库编码' }
                    ],
                    'tableConfig': [
                        { 'prop': 'whCode', 'value': '仓库编码' },
                        { 'prop': 'cdwhName', 'value': '仓库名称' }
                    ],
                    'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                    'cbParams': [
                        'whCode#whCode', 'cdwhName#whName'
                    ],
                    'type': 'advance',
                    width: '120',
                    noShowTooltip: true,
                    'advanceCascade': 'siteCode,siteName'
                },
                {
                    'label': '仓库名称',
                    value: 'whName',
                    'prop': 'whName',
                    'mustFill': true,
                    'advanceConfig': [
                        { 'prop': 'transferCenterName', 'value': '仓库名称' },
                        { 'prop': 'transferCenterCode', 'value': '仓库编码' }
                    ],
                    'tableConfig': [
                        { 'prop': 'transferCenterCode', 'value': '仓库编码' },
                        { 'prop': 'transferCenterName', 'value': '仓库名称' },
                        { 'prop': 'siteCode', 'value': '平台编码' },
                        { 'prop': 'siteName', 'value': '平台名称' }
                    ],
                    'prefix': '/api-dc/',
                    'advanceUrl': 'transfer/center/config/page?enableFlag=1&enableTenant=0',
                    'cbParams': [
                        'transferCenterCode#whCode', 'transferCenterName#whName'
                    ],
                    width: '120',
                    noShowTooltip: true
                    // 'advanceCascade': 'siteCode,siteName'
                }
            ]
        };
    },
    computed: {
        transferFlagOptionsDisabled(option, index) {
            return function(option, index) {
                // 非YS DO 第一个站点不能选是(sortNo 从2 开始的都可以选)
                if (+option.value === 1 && !['YS', 'DO'].includes(this.formData.orderType) && index === 0) {
                    return true;
                }
                return false;
            };
        }
    },
    methods: {
        // 纯运输、分拨订单站点从2开始
        getSortNo(index = 0) {
            const sortNo = index + (['YS', 'DO'].includes(this.formData.orderType) ? 2 : 1);
            return sortNo;
        },
        editClick(row, index) {
            this.$set(row, 'edit', true);
        },
        deleteClick(row, index) {
            this.tableData.splice(index, 1);
            this.tableData.forEach((item, index) => {
                item.sortNo = this.getSortNo(index);
            });
            this.changeSetData();
        },
        addDialogRow() {
            const obj = {
                edit: true,
                siteCode: '',
                whCode: '',
                stationType: 'PROPRIETARY',
                transferFlag: '0'
            };
            this.tableData.push(obj);
            this.tableData.forEach((item, index) => {
                item.sortNo = this.getSortNo(index);
            });
        },
        async getTransferSiteData(params) {
            let transferSiteData = {};
            await getTransferSite(params).then(res => {
                if (res) {
                    if (res.data.list && res.data.list.length > 0) {
                        transferSiteData = res.data.list[0];
                    }
                }
            });
            return transferSiteData;
        },
        async getAdvanceValue(data, prop, scope) {
            const index = scope.$index;
            const row = scope.row;
            Object.keys(data).forEach(k => {
                this.tableData[index][k] = data[k];
            });
            if (prop === 'siteName') {
                this.$set(this.tableData[index], 'whName', '');
                this.$set(this.tableData[index], 'whCode', '');
            }
            if (prop === 'whName' && row.whCode) {
                if (row.whCode) {
                    if (!(index === 0 && !['YS'].includes(this.formData.orderType))) {
                        const params = {
                            transferCenterCode: row.whCode,
                            transferCenterName: row.whName
                        };
                        const transferSiteData = await this.getTransferSiteData(params).finally(() => {}) || {};
                        row.siteName = transferSiteData.siteName;
                        row.siteCode = transferSiteData.siteCode;
                        row.stationType = transferSiteData.stationType || 'PROPRIETARY';
                        if (transferSiteData.operationMode) {
                            row.transferFlagDisabled = true;
                            row.transferFlag = transferSiteData.operationMode === 'TRANSFER' ? '1' : '0';
                        } else {
                            row.transferFlag = '';
                            row.transferFlagDisabled = false;
                        }
                    }
                } else {
                    row.siteName = row.siteCode = '';
                    row.stationType = 'PROPRIETARY';
                    row.transferFlag = '';
                    row.transferFlagDisabled = false;
                }
            }
            // 修改站点仓库时，头部信息联动
            this.changeSetData();
        },
        changeSetData() {
            // 纯运输第一条数据（站点2）和分拨仓联动   非纯运输第二条数据和分拨仓联动 第一条数据和平台仓库联动
            if (!['YS'].includes(this.formData.orderType)) {
                if (this.tableData.length) {
                    this.$set(this.formData, 'siteCode', this.tableData[0].siteCode);
                    this.$set(this.formData, 'siteName', this.tableData[0].siteName);
                    this.$set(this.formData, 'whCode', this.tableData[0].whCode);
                    this.$set(this.formData, 'whName', this.tableData[0].whName);
                } else {
                    this.formData.siteCode = this.formData.siteName = this.formData.whCode = this.formData.whName = '';
                }
                if (this.tableData.length > 1) {
                    this.$set(this.formData, 'distributionWhCode', this.tableData[1].whCode);
                    this.$set(this.formData, 'distributionWhName', this.tableData[1].whName);
                } else {
                    this.formData.distributionWhCode = this.formData.distributionWhName = '';
                }
            } else {
                if (this.tableData.length) {
                    this.$set(this.formData, 'distributionWhCode', this.tableData[0].whCode);
                    this.$set(this.formData, 'distributionWhName', this.tableData[0].whName);
                } else {
                    this.formData.distributionWhCode = this.formData.distributionWhName = '';
                }
            }
        }
    },
    filters: {
        stationTypeFilter: function(val, stationTypeOptions) {
            let str = '';
            stationTypeOptions.forEach(item => {
                if (item.value === val + '') {
                    str = item.label;
                }
            });
            return str;
        },
        transferFlagFilter: function(val) {
            if (val) {
                return +val === 1 ? '是' : '否';
            }
            return '';
        }
    }
};
</script>